module.exports = __webpack_public_path__ + "static/img_0391-d6d4ebe39f6487382817e5d071f93d65.webp";